import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.mjs';

/* script */

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"1em","height":"1em","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"clip-path":"url(#global-userFilled-small-clip0)"}},[_c('path',{attrs:{"d":"M7.88599 7.70728C8.94482 7.70728 9.86169 7.32751 10.6108 6.57825C11.36 5.8291 11.7397 4.91248 11.7397 3.85352C11.7397 2.79492 11.36 1.87817 10.6107 1.12878C9.86145 0.379761 8.9447 0 7.88599 0C6.82703 0 5.9104 0.379761 5.16125 1.12891C4.41211 1.87805 4.03223 2.7948 4.03223 3.85352C4.03223 4.91248 4.41211 5.82922 5.16138 6.57837C5.91064 7.32739 6.82739 7.70728 7.88599 7.70728Z","fill":"currentColor"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14.629 12.3032C14.6074 11.9915 14.5637 11.6514 14.4994 11.2922C14.4344 10.9304 14.3508 10.5884 14.2507 10.2758C14.1473 9.95264 14.0067 9.63354 13.8329 9.32776C13.6525 9.01038 13.4406 8.73401 13.2028 8.50659C12.9541 8.26868 12.6497 8.07739 12.2976 7.93787C11.9468 7.79907 11.558 7.72876 11.1421 7.72876C10.9788 7.72876 10.8208 7.79578 10.5157 7.99438C10.328 8.11682 10.1084 8.25842 9.86328 8.41504C9.65369 8.54858 9.36975 8.67371 9.01904 8.78699C8.67688 8.89771 8.32947 8.95386 7.98657 8.95386C7.64368 8.95386 7.29639 8.89771 6.95386 8.78699C6.60352 8.67383 6.31958 8.54871 6.11023 8.41516C5.86743 8.26001 5.64771 8.11841 5.45715 7.99426C5.15247 7.79565 4.99438 7.72864 4.83105 7.72864C4.41504 7.72864 4.02637 7.79907 3.67566 7.93799C3.32385 8.07727 3.01929 8.26855 2.77039 8.50671C2.53271 8.73425 2.32068 9.0105 2.1405 9.32776C1.9668 9.63354 1.82617 9.95251 1.72266 10.2759C1.62268 10.5885 1.53906 10.9304 1.47412 11.2922C1.40979 11.6509 1.36609 11.9911 1.34448 12.3036C1.32324 12.6097 1.3125 12.9275 1.3125 13.2484C1.3125 14.0836 1.578 14.7598 2.10156 15.2584C2.61865 15.7505 3.30286 16.0001 4.13489 16.0001H11.839C12.671 16.0001 13.355 15.7506 13.8722 15.2584C14.3959 14.7601 14.6614 14.0839 14.6614 13.2483C14.6613 12.9259 14.6504 12.6079 14.629 12.3032Z","fill":"currentColor"}})]),_vm._v(" "),_c('defs',[_c('clipPath',{attrs:{"id":"global-userFilled-small-clip0"}},[_c('rect',{attrs:{"width":"16","height":"16.0001","fill":"white"}})])])])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    {},
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
